// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AkunRouteImport } from './routes/akun'
import { Route as CaraKerjaRouteImport } from './routes/cara-kerja'
import { Route as KontakRouteImport } from './routes/kontak'
import { Route as PaketRouteImport } from './routes/paket'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RedaksiRouteImport } from './routes/redaksi'
import { Route as ReferralRouteImport } from './routes/referral'
import { Route as RekapRouteImport } from './routes/rekap'
import { Route as RiwayatRouteImport } from './routes/riwayat'
import { Route as StatusRouteImport } from './routes/status'
import { Route as TentangRouteImport } from './routes/tentang'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ProdukSlugRouteImport } from './routes/produk.$slug'
import { Route as TransaksiOrderIdRouteImport } from './routes/transaksi.$orderId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AkunRoute = AkunRouteImport.update({
            id: '/akun',path: '/akun',getParentRoute: () => rootRouteImport
          })
const CaraKerjaRoute = CaraKerjaRouteImport.update({
            id: '/cara-kerja',path: '/cara-kerja',getParentRoute: () => rootRouteImport
          })
const KontakRoute = KontakRouteImport.update({
            id: '/kontak',path: '/kontak',getParentRoute: () => rootRouteImport
          })
const PaketRoute = PaketRouteImport.update({
            id: '/paket',path: '/paket',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RedaksiRoute = RedaksiRouteImport.update({
            id: '/redaksi',path: '/redaksi',getParentRoute: () => rootRouteImport
          })
const ReferralRoute = ReferralRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => rootRouteImport
          })
const RekapRoute = RekapRouteImport.update({
            id: '/rekap',path: '/rekap',getParentRoute: () => rootRouteImport
          })
const RiwayatRoute = RiwayatRouteImport.update({
            id: '/riwayat',path: '/riwayat',getParentRoute: () => rootRouteImport
          })
const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const TentangRoute = TentangRouteImport.update({
            id: '/tentang',path: '/tentang',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ProdukSlugRoute = ProdukSlugRouteImport.update({
            id: '/produk/$slug',path: '/produk/$slug',getParentRoute: () => rootRouteImport
          })
const TransaksiOrderIdRoute = TransaksiOrderIdRouteImport.update({
            id: '/transaksi/$orderId',path: '/transaksi/$orderId',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,AkunRoute: AkunRoute,CaraKerjaRoute: CaraKerjaRoute,KontakRoute: KontakRoute,PaketRoute: PaketRoute,PrivacyRoute: PrivacyRoute,RedaksiRoute: RedaksiRoute,ReferralRoute: ReferralRoute,RekapRoute: RekapRoute,RiwayatRoute: RiwayatRoute,StatusRoute: StatusRoute,TentangRoute: TentangRoute,TermsRoute: TermsRoute,BlogSlugRoute: BlogSlugRoute,ProdukSlugRoute: ProdukSlugRoute,TransaksiOrderIdRoute: TransaksiOrderIdRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)